import React from 'react';

import UserInput from "../UI/ReactUserInput";
import UserInputCheckbox from "../UI/ReactUserInputCheckbox";
import DropdownRole from "root/ReactHookForm/ui/DropdownRole";
import {UserTypes} from "root/DataFunctions/Constants";
import {checkError} from 'root/DataFunctions/BaseDataFns'

export default class UserEditForm2 extends React.Component
{
	 static get defaultProps()
	{
		return {
			title: null,
			passwordRequired: true, 
			addressRequired: true, 
			showButtons: true
		} ;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

		// Create a state item here for all items on the form  (Using their id )
		// If you don't create an initial entry here for each input field on the form, then React will assume they are
		// UNCONTROLLED and issue a warning at runtime
		//
		// displayErrors is passed to child controls for force them to display their validity state (for example if the SAVE button is pressed )

		this.state = {
				displayErrors: false ,
				showButtons: this.props.showButtons,
				buttonState: '',
				userType: this.props.userType,
				user: this.props.user,
				passwordMismatch: false 
		};
        
	}

	componentDidUpdate(prevProps, prevState)
	{
		if (this.props.userType !== this.state.userType )
		{
			this.setState ( { userType: this.props.userType })
		}
	}

	UNSAFE_componentWillMount()
	{
		// This component supports create and edit of users so we need to cater for 
		/// both in the construction of the form
		
		if ( this.props.mode == 'edit' || this.props.mode == 'change' || this.props.mode == 'view' || this.props.mode == 'delete' )
		{
			var userid = this.props.userid ;
			
			if ( userid != null )
			{
				// Fetch the child data for this ESW
				this.getdata (userid) ;			
			}
		
		}							
	}

	UNSAFE_componentWillReceiveProps(nextProps)
	{
		if ( nextProps == 'edit' || nextProps == 'view' || nextProps == 'delete' )
		{
			var userid = this.props.userid ;
			
			if ( userid != null )
			{
				// Fetch the child data for this ESW
				this.getdata (userid) ;			
			}
		}

		 this.setState ({ 			 
			 showButtons: nextProps.showButtons,
			 user: nextProps.user
		 }) ;
								
	}

	getdata( userid )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
    	$.ajax({
    		  type: 'GET',
    		  url: root + '/users/' + userid  ,
    		  success:(data)=>{
    			  var el = data.data[0] ;
    			  
    			  this.setState ( {
    			  	  userType: el.userTypeId, 
    			  	  user: { 
    			  	  	InputUserName: el.username,
					  	InputFirstName: el.firstname,
					  	InputSurname: el.surname, 
					  	InputEmail: el.email,
					  	InputTelephone: el.telNo,
					  	InputPassword1: '', 
		              	InputPassword2: ''
					}}) ;
    			  
  				// this.setStateFromData(data.data);
  				
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
		  		}

    		});
	}

	createESW( forename, surname, password )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var j = { 'esw_forename': forename, 'esw_surname': surname, 'esw_password': password } ;
		
		var utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'POST',
    		  url: root + '/esws',
    		  //dataType: "json",
    		  //contentType: "application/json; charset=utf-8",
    		  
    		  data: j ,
    		  success:(data)=>{

    			var message = "Created new ESW. Click OK to return" ;
        			  
    			// Display confirmation using the Bootbox library
    			// http://bootboxjs.com/
    			var utype1 = utype ;
    			
    			bootbox.alert({ 
    				  size: "large",
    				  title: "Operation completed",
    				  message: message, 
    				  callback: function()
    				  { 
    						// return using the filter we originally came in with 
    						var url = 'view_users.php?usertype=' + utype1 
    							
    						location.assign(url);
    				  }
    				})
  				
    		    // successful request; do something with the data
    		    //$('#exampleTextarea').empty();
    		    //$('#exampleTextarea').val(data.name);
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
		  		}

    		});
	}

	updateUser( userid, forename, surname )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var j = { 'forename': forename, 'surname': surname } ;
		
	    //var JSON = '{"esw_forename": "' + forename + '" }' ;
		
		var utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'PUT',
    		  url: root + '/users/'+userid,
    		  //dataType: "json",
    		  //contentType: "application/json; charset=utf-8",
    		  
    		  data: j ,
    		  success:(data)=>{

    			if (checkError(data))
				{
        			var message = "Updated user details. Click OK to return" ;
      			  
        			// Display confirmation using the Bootbox library
        			// http://bootboxjs.com/
        			var utype1 = utype ;
        			
        			bootbox.alert({ 
        				  size: "large",
        				  title: "Operation completed",
        				  message: message, 
        				  callback: function()
        				  { 
        						// return using the filter we originally came in with 
        						var url = 'view_users.php?usertype=' + utype1; 
        							
        						location.assign(url);
        				  }
        				})				
				}

  				
    		    // successful request; do something with the data
    		    //$('#exampleTextarea').empty();
    		    //$('#exampleTextarea').val(data.name);
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
		  		}

    		});
	}
	
	
	SendLoginInvitationToUser( userid )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var me = this ;
		
    	$.ajax({
    		  type: 'PUT',
    		  url: root + '/desipersons/'+userid+'/invite',    		  
    		  data: {} ,
    		  success:(data)=>{

    			if (checkError(data))
				{
    				let user_id = userid ;
    				
        			var message = "Invitation sent. Click OK" ;
      			  
        			bootbox.alert({ 
        				  size: "large",
        				  title: "Operation completed",
        				  message: message, 
        				  callback: function()
        				  { 
        					  let user = me.state.user ;
        					  
        					  user.login_enabled = 1 ;
        					  
        					  me.setState ( { user: user }) ;
         				  }
        				})				
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					handleAjaxError (jqXHR, textStatus, error) ;    		  	
		  		}

    		});
	}

	

	doPasswordResetForUser( userid )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var j = {} ;
		
    	$.ajax({
    		  type: 'PUT',
    		  url: root + '/users/'+userid+'/resetpassword',    		  
    		  data: j ,
    		  success:(data)=>{

    			if (checkError(data))
				{
        			let message = "Password reset issued. Click OK" ;
      			  
        			bootbox.alert({ 
        				  size: "large",
        				  title: "Operation completed",
        				  message: message, 
        				  callback: function()
        				  { 
        				  }
        				})				
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>
			  {
					handleAjaxError (jqXHR, textStatus, error);
			  }
    	});
	}
	
	doSuspendUser( userid )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var j = {} ;
		
		var me = this ;
		
    	$.ajax({
    		  type: 'PUT',
    		  url: root + '/users/'+userid+'/suspend',    		  
    		  data: j ,
    		  success:(data)=>{

    			if (checkError(data))
				{
        			var message = "User Suspended. Click OK" ;
      			  
        			bootbox.alert({ 
        				  size: "large",
        				  title: "Operation completed",
        				  message: message, 
        				  callback: function()
        				  { 
        					  var user = me.state.user ;

        					  user.login_suspended = 1 ;
        					  
        					  me.setState ({ user: user }) ;
        				  }
        				})				
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>
			  {
				  handleAjaxError (jqXHR, textStatus, error);
			  }
    		});
	}
	
	doUnSuspendUser( userid )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var j = {} ;
		
		var me = this ;
		

    	$.ajax({
    		  type: 'PUT',
    		  url: root + '/users/'+userid+'/unsuspend',    		  
    		  data: j ,
    		  success:(data)=>{

    			if (checkError(data))
				{
        			var message = "User Un-Suspended. Click OK" ;
      			  
        			bootbox.alert({ 
        				  size: "large",
        				  title: "Operation completed",
        				  message: message, 
        				  callback: function()
        				  { 
        					  var user = me.state.user ;

        					  user.login_suspended = null ;
        					  
        					  me.setState ({ user: user }) ;
        				  }
        				})				
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>
			  {
				  handleAjaxError (jqXHR, textStatus, error);
			  }

    		});
	}
	
	addressIsValid()
	{
		if ( this.props.addressRequired == true )
		{
			if ( this.refs.InputAddress1.isValid() &&
				 this.refs.InputAddress2.isValid() && 
				 this.refs.InputAddress3.isValid() &&
				 this.refs.InputAddress4.isValid() &&
				 this.refs.InputPostcode.isValid())
			 {
				return true ;
			 }
			 else
			 {
			 	return false ;
			 }
		}		
		else
		{
			return true ;
		}
	}	

	formIsValid ()
	{		
		var rVal = true ;

		if ( this.props.mode == 'edit')
		{
			if ( this.refs.InputFirstName.isValid() && 
					 this.refs.InputLastName.isValid() && 
					 this.refs.InputEmail.isValid() && 
					 this.refs.InputTelephone.isValid() &&
					 this.addressIsValid())
					 
				{
					rVal = true ;
				}
				else
				{
					rVal = false ;
				}	
		}
		else if ( this.props.mode == 'create')
		{
			if ( this.refs.InputFirstName.isValid() && 
				 this.refs.InputLastName.isValid() && 
				 this.refs.InputEmail.isValid() && 
				 this.refs.InputTelephone.isValid() && this.addressIsValid())

			{					
				if ( this.props.passwordRequired == true )
				{
					if ( this.refs.InputPassword1.isValid())
					{
						rVal = true ;
					}
					else
					{
						rVal = false ;
					}
				}
				else
				{
					rVal = true ;					
				}
			}
			else
			{
				rVal = false ;
			}			
		}
		else if ( this.props.mode == 'delete')
		{
			rVal = true ;
		}
		
		return rVal ;
	}
	
	booleanToInt( val )
	{
		if ( val == true )
		{
			return 1 ;
		}
		else
		{
			return 0;
		}
	}
	
	getFormData()
	{
		var carerDetailFormFields = this.refs ;

		// Take the original user record as a stsrting point so we preserve the 
		// user ID if there was one

		var carerDetails = this.state.user ;

		// Now overwrite all the values

		carerDetails.firstname = carerDetailFormFields.InputFirstName.getValue() ;
		carerDetails.lastname = carerDetailFormFields.InputLastName.getValue() ;

		carerDetails.telephone = carerDetailFormFields.InputTelephone.getValue() ;
		carerDetails.email = carerDetailFormFields.InputEmail.getValue() ;

		if ( this.props.addressRequired == true )
		{
			carerDetails.address1 = carerDetailFormFields.InputAddress1.getValue() ;
			carerDetails.address2 = carerDetailFormFields.InputAddress2.getValue() ;
			carerDetails.address3 = carerDetailFormFields.InputAddress3.getValue() ;
			carerDetails.address4 = carerDetailFormFields.InputAddress4.getValue() ;
			carerDetails.postcode = carerDetailFormFields.InputPostcode.getValue() ;
		}

		if ( this.props.passwordRequired == true )
		{
			carerDetails.password = carerDetailFormFields.InputPassword1.getValue() ;
		}

        carerDetails.login_enabled = 0 ;

        if ( this.showLoginFlag())
		{
			if ( carerDetailFormFields.InputUserCanLogin != null )
			{
                carerDetails.login_enabled = this.booleanToInt(carerDetailFormFields.InputUserCanLogin.getValue()) ;
			}
		}
		
		return carerDetails ;
	}
	
	onSave() 
	{
		var doSave = true ;
		
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			if ( this.props.passwordRequired == true )
			{
				var p1 = this.refs.InputPassword1.getValue() ;
				var p2 = this.refs.InputPassword2.getValue() ;
				
				if ( p1 != p2 )
				{
					this.setState ( { displayErrors : true, passwordMismatch: true  })	;
					doSave = false ;
				}
			}

			if ( doSave )
			{			
				//var username = this.refs.InputUserName.getValue();
	
				var firstname = this.refs.InputFirstName.getValue();
				var surname = this.refs.InputLastName.getValue();
				var email = this.refs.InputEmail.getValue();
				var telephone = this.refs.InputTelephone.getValue();
	
				if ( this.props.addressRequired == true )
				{
					var address1 = this.refs.InputAddress1.getValue();
					var address2 = this.refs.InputAddress2.getValue();
					var address3 = this.refs.InputAddress3.getValue();
					var address4 = this.refs.InputAddress4.getValue();

					var postcode = this.refs.InputPostcode.getValue();					
				}

				//var p1 = this.state.user.InputPassword1;
				//var p2 = this.state.user.InputPassword2;
				
				var type = this.state.userType ;
	
				if ( this.props.onSave != null )
				{
					// We are acting as an inline form

					if ( this.props.addressRequired == true )
					{
						var ob = { user_id: 0,
								   id: 0, 
								   name: null,
								   email: email,
								   firstname: firstname,
								   surname: surname,
								   telephone: telephone,
								   postcode: postcode,
								   address1: address1,
								   address2: address2,
								   address3: address3,
								   address4: address4						   
								   } ;
					}
					else
					{
						var ob = { user_id: 0,
								   id: 0, 
								   name: null,
								   email: email,
								   firstname: firstname,
								   surname: surname,
								   telephone: telephone,
								   } ;

					}
					
					// Pass the form details back to the calling form
					this.props.onSave ( ob ) ;				
	
				}
				else
				{
					if ( this.props.mode == 'create')
					{
						if ( type == 3 )
						{
							// ESW

							this.createESW ( firstname, lastname, p1) ;
						}					
					}
					else
					{
						if ( this.props.mode == 'edit')
						{
							this.updateUser ( this.props.userid, firstname, lastname ) ;
						}			
					}			
				}
			}
		}
	}

	PasswordResetForUser()
	{
		this.doPasswordResetForUser(this.state.user.idusers) ;
	}

	onResetPassword()
	{
		var me = this ;
		var dialog = bootbox.dialog({
			title: 'Reset Password',
			message: "<p>You are about to reset this user's password. Click OK to confirm</p>",
			buttons: {
				cancel: {
					label: "Cancel",
					className: 'btn-secondary',
					callback: function()
					{
					}
				},
				ok: {
					label: "OK",
					className: 'btn-info',
					callback: function()
					{
						me.PasswordResetForUser() ;
					}
				}
			}
			});
	}

	onSendInvite()
		{
		var me = this ;
		var dialog = bootbox.dialog({
			title: 'Send Login Invitation',
			message: "<p>You are about to send this teacher an invitation to join the ePEP system as a logged in user. Click OK to confirm</p>",
			buttons: {
				cancel: {
					label: "Cancel",
					className: 'btn-secondary',
					callback: function()
					{
					}
				},
				ok: {
					label: "OK",
					className: 'btn-info',
					callback: function()
					{
						me.SendLoginInvitationToUser(me.state.user.idusers) ;
					}
				}
			}
			});
	}

	onSuspendUser()
	{
		var me = this ;
		var dialog = bootbox.dialog({
			title: 'Suspend User',
			message: "<p>You are about to suspend this user's account. Click OK to confirm</p>",
			buttons: {
				cancel: {
					label: "Cancel",
					className: 'btn-secondary',
					callback: function()
					{
					}
				},
				ok: {
					label: "OK",
					className: 'btn-info',
					callback: function()
					{
						me.doSuspendUser(me.props.user.idusers) ;
					}
				}
			}
			});
	}
	
	onUnSuspendUser()
	{
		var me = this ;
		var dialog = bootbox.dialog({
			title: 'Unsuspend User',
			message: "<p>You are about to restore this user's account. Click OK to confirm</p>",
			buttons: {
				cancel: {
					label: "Cancel",
					className: 'btn-secondary',
					callback: function()
					{
					}
				},
				ok: {
					label: "OK",
					className: 'btn-info',
					callback: function()
					{
						me.doUnSuspendUser(me.props.user.idusers) ;
					}
				}
			}
			});
	}
	
	onDelete() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			this.props.onDelete(this.props.userid) ;
		}	
	}
	
	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			this.props.onCancel() ;
		}
		else
		{
			var url = atob ( this.props.return_url ) ;
			
			location.assign(url);		
		}
	}
	

	rowName()
	{
        var lineList=[];	
        
		var fieldType = '';
		
		if ( this.props.readonly == true  || this.props.mode == 'view')
		{
			fieldType = "readonly";
		}

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: true, maxlen: 30 },
        			  name: 'InputFirstName',
        			  ref: 'InputFirstName',
        			  labelText: 'First Name', 
        			  errorText: 'You must enter a valid first name',
        			  value: this.state.user.firstname,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  key: this.keyCount++
        			  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: true, maxlen: 30 },
        			  name: 'InputLastName',
        			  ref: 'InputLastName',
        			  labelText: 'Last Name', 
        			  errorText: 'You must enter a valid last name',
        			  value: this.state.user.surname,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  key: this.keyCount++
        			  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	rowUserName()
	{
		var lineList=[];

		let fieldType = "readonly";

		lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-12'},
			React.createElement ( UserInput, { validation: { required: true, maxlen: 30 },
				id: 'InputUserName',
				name: 'InputUserName',
				ref: 'InputUserName',
				labelText: 'User (Login) Name',
				errorText: 'You must enter a valid user name',
				value: this.state.user.username,
				readOnly: fieldType,
				displayErrors:this.state.displayErrors,
				key: this.keyCount++
			}))) ;

		return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	getEmailRequiredFlag()
	{
		var result = true ;

		if ( this.state.userType == 10 )
		{
			result = false ;
		}

		return result ;
	}

	isSchoolBasedRole ( type )
	{
		return ( type == USER_TYPE_DESI_TEACHER || type == USER_TYPE_ATTENDANCE_OFFICER ) ? true : false ;
	}

	getTelephoneRequiredFlag()
	{
		var result = true ;

		if ( this.isSchoolBasedRole(this.state.userType))
		{
			result = false ;
		}

		return result ;
	}

	getAddressRequiredFlag()
	{
		var result = true ;

		if ( this.isSchoolBasedRole(this.state.userType))
		{
			result = false ;
		}

		return result ;
	}
	
	rowEmailAndPhone()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.props.readonly == true  || this.props.mode == 'view')
		{
			fieldType = "readonly";
		}
		
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { 
        			  validation: { required: this.getEmailRequiredFlag(), maxlen: 100 , isEmail: true},
        			  id: 'InputEmail', 
        			  name: 'InputEmail',
        			  ref: 'InputEmail',
        			  labelText: 'Email Address', 
        			  errorText: 'You must enter a valid email address',
        			  value: this.state.user.email,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  key: this.keyCount++
        			  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: this.getTelephoneRequiredFlag(), maxlen: 25, isTelephone: true },
        			  id: 'InputTelephone', 
        			  name: 'InputTelephone',
        			  ref: 'InputTelephone',
        			  labelText: 'Telephone Number', 
        			  errorText: 'You must enter a valid phone number',
        			  value: this.state.user.telephone,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  key: this.keyCount++
        			  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	rowAddressLine1()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.props.readonly == true  || this.props.mode == 'view')
		{
			fieldType = "readonly";
		}
		
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: this.getAddressRequiredFlag(), maxlen: 50 },
        	  		  id: 'InputAddress1', 
        	  		  name: 'InputAddress1',
        	  		  ref: 'InputAddress1',
        	  		  labelText: 'Address 1', 
        	  		  errorText: 'You must enter a valid address',
        	  		  value: this.state.user.address1,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: this.getAddressRequiredFlag(), maxlen: 50 },
        	  		  id: 'InputAddress2', 
        	  		  name: 'InputAddress2',
        	  		  ref: 'InputAddress2',
        	  		  labelText: 'Address 2', 
        	  		  errorText: 'You must enter a valid address',
        	  		  value: this.state.user.address2,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}
	
	rowAddressLine2()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.props.readonly == true  || this.props.mode == 'view')
		{
			fieldType = "readonly";
		}
		
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: false, maxlen: 50 },
        	  		  id: 'InputAddress3', 
        	  		  name: 'InputAddress3',
        	  		  ref: 'InputAddress3',
        	  		  labelText: 'Address3', 
        	  		  errorText: 'You must enter a valid address',
        	  		  value: this.state.user.address3,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: false, maxlen: 50 },
        	  		  id: 'InputAddress4', 
        	  		  name: 'InputAddress4',
        	  		  ref: 'InputAddress4',
        	  		  labelText: 'Address 4', 
        	  		  errorText: 'You must enter a valid address',
        	  		  value: this.state.user.address4,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	rowPostcode()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.props.readonly == true  || this.props.mode == 'view')
		{
			fieldType = "readonly";
		}
		
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'})) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: false, maxlen: 10, isPostcode: true },
        	  		  id: 'InputPostcode', 
        	  		  name: 'InputPostcode',
        	  		  ref: 'InputPostcode',
        	  		  labelText: 'Postcode', 
        	  		  style: { textTransform: 'uppercase'} ,
        	  		  errorText: 'You must enter a valid postcode',
        	  		  value: this.state.user.postcode,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	showLoginFlag()
	{
		return +(this.state.user.userTypeId) === UserTypes.DESI_TEACHER;
	}

	userTypeHasLogin()
	{
		const ut = +(this.state.user.userTypeId);

		return ut === UserTypes.DESI_TEACHER || ut === UserTypes.ESW || ut === UserTypes.VIRTUAL_SCHOOL_HEAD ||
			ut === UserTypes.PERSONAL_ASSISTANT || ut === UserTypes.TEAM_LEAD || ut === UserTypes.PERFORMANCE_AND_DEVELOPMENT ||
			ut === UserTypes.EDUCATIONAL_PSYCHOLOGIST || ut === UserTypes.ATTENDANCE_OFFICER || ut === UserTypes.LEAD_CAREERS_ADVISOR;
	}

	showInviteFlag()
	{
		if ( +(this.state.user.userTypeId) === UserTypes.DESI_TEACHER && this.canUserLogin() == false )
		{
			return true ;
		}
		else
		{
			return false ;
		}
	}
	
	canUserLogin()
	{
		if ( this.state.user.login_enabled == 1 )
		{
			if ( +(this.state.user.userTypeId) !== UserTypes.SOCIAL_WORKER )
			{
				// Don't show password reset for Social Workers
                return true ;
			}
			else
			{
				return false ;
			}
		}
		else
		{
			return false ;
		}
	}
	
	rowCanLogin()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.props.readonly == true || this.props.mode == 'view')
		{
			fieldType = "readonly";
		}

		var canLogin = this.canUserLogin();

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-12'},
        		React.createElement ( UserInputCheckbox, { 
        		    readOnly: fieldType,
        			ref: 'InputUserCanLogin',
        			defaultValue: canLogin,
        			key: this.keyCount++, 
        			label: 'Is the Designated Teacher required to login?' }, null ))) ;
        

        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}
	
	rowPassword()
	{
        var lineList=[];	
		
		var fieldType =  this.props.readonly == true  || this.props.mode == 'view' ? "readonly" : '';

		if ( this.state.passwordMismatch == true )
		{
			var errText = "Passwords must match" ;
		}
		else
		{
			var errText = 'Password must be at least 8 characters and contain uppercase, lowercase and a number' ;
		}
		
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { 
        			  validation: { required: false, maxlen: 50 , isPassword: true},
        			  id: 'InputPassword1', 
        			  name: 'InputPassword1',
        			  ref: 'InputPassword1',
        			  labelText: 'Password', 
        			  errorText: errText,
        			  value: this.state.user.password1,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  passwordMismatch: this.state.passwordMismatch,
        			  key: this.keyCount++
        			  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: true, maxlen: 50, isPassword: true },
        			  id: 'InputPassword2', 
        			  name: 'InputPassword2',
        			  ref: 'InputPassword2',
        			  labelText: 'Confirm Password', 
        			  errorText: errText,
        			  value: this.state.user.password2,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  passwordMismatch: this.state.passwordMismatch,
        			  key: this.keyCount++
        			  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}
	

	buttonRow ()
    {
        var lineList=[];
        
        if ( this.props.showButtons == true )
        {
	        	
	        if ( this.props.mode == 'delete')
	    	{
	            lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;
	
	            lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
	            		 React.createElement('button', { id: 'SaveButton', type: 'button', disabled: this.state.buttonState, className: 'btn btn-danger', style: { float: 'right', marginRight: '15px' } , onClick: this.onDelete.bind(this) }, 'Delete'),
	               		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))
	    	
	    	}
	        else if ( this.props.mode == 'edit')
	    	{
	        		if ( this.canUserLogin())
        			{
	        			var btnList = [] ;
	        			
	        			btnList.push ( React.createElement('button', { key: this.keyCount++, id: 'PasswordReseteButton', type: 'button', className: 'btn btn-warning', style: { float: 'left', marginLeft: '0px' } , onClick: this.onResetPassword.bind(this) }, 'Reset Password')) ;
	        			
	        			if ( this.state.user.login_suspended == null )
        				{
		        			btnList.push ( React.createElement('button', { key: this.keyCount++, id: 'SuspendUserButton', type: 'button', className: 'btn btn-danger', style: { float: 'left', marginLeft: '10px' } , onClick: this.onSuspendUser.bind(this) }, 'Suspend User')) ;        				
        				}
	        			else
        				{
		        			btnList.push ( React.createElement('button', { key: this.keyCount++, id: 'UnSuspendUserButton', type: 'button', className: 'btn btn-danger', style: { float: 'left', marginLeft: '10px' } , onClick: this.onUnSuspendUser.bind(this) }, 'Unsuspend User')) ;        				        				
        				}
	        			
			            lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-5'}, btnList )) ;
        			
        			}
	        		else
        			{
			            lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-5'},null)) ;
        			}
		
		            lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-4'},null)) ;
		            
	                lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
	                		 React.createElement('button', { id: 'SaveButton', type: 'button', disabled: this.state.buttonState, className: 'btn btn-primary', style: { float: 'right' , marginRight: '0px'} , onClick: this.onSave.bind(this) }, 'Save'),
	                   		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))
	        	
	    	}
	        else if ( this.props.mode == 'create')
	    	{
		            lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;
		            
	                lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
	                		 React.createElement('button', { id: 'SaveButton', type: 'button', disabled: this.state.buttonState, className: 'btn btn-primary', style: { float: 'right' , marginRight: '0px'} , onClick: this.onSave.bind(this) }, 'Save'),
	                   		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))
	        	
	    	}
	        else
        	{
	            lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

	            lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
                  		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '0px' }, onClick: this.onCancel.bind(this) }, 'Cancel'))) ;
	        	
        	}
	           		        
	        return React.createElement('div', { key: this.keyCount++, className: 'row',  style: {marginTop: '15px' , marginBottom: '15px' }}, lineList ); 
        }
        else
    	{
	        return React.createElement('div', { key: this.keyCount++, className: 'row'});    	
    	}

    }
	
	inviteToLoginRow ()
    {
        var lineList=[];
        
        if ( this.props.showButtons == true )
        {
        	if ( this.props.mode == 'edit')
	    	{
        		if ( this.state.user.email == null || this.state.user.email == '' )
    			{
        			lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-12', style: { color: '#d83333'}},"This teacher cannot currently be invited to login because they do not have an email address.")) ;    			
    			}
        		else
    			{
        			lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9', style: { color: '#d83333'}},"This teacher is not currently enabled for system Login, Click the button to send them login credentials")) ;
		            
	                lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
	                		 React.createElement('button', { id: 'InviteButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' , marginRight: '0px'} , onClick: this.onSendInvite.bind(this) }, 'Send Invitation')));
    			
    			}
	    	}
	           		        
	        return React.createElement('div', { key: this.keyCount++, className: 'row',  style: {marginTop: '15px' , marginBottom: '15px' }}, lineList ); 
        }
        else
    	{
	        return React.createElement('div', { key: this.keyCount++, className: 'row'});    	
    	}

    }	
	
	rowAltPassword ( text )
	{
        var lineList=[];

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-12', style: { marginTop: '10px'}},
        		React.createElement ( 'span', { 
        			  key: this.keyCount++
        			  }, text))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );		
	}

	isTeacher ()
	{
		return this.props.user_type == USER_TYPE_DESI_TEACHER ? true : false ;
	}

	mainFormElement ()
    {
	    var lineList=[];
	    
	    lineList.push ( this.rowName()) ;

	    if ( this.props.mode != 'create' &&  this.userTypeHasLogin() && !this.isTeacher())
		{
			lineList.push ( this.rowUserName()) ;
		}

	    lineList.push ( this.rowEmailAndPhone()) ;
	    
	    if ( !this.showInviteFlag())
    	{
		    if ( this.showLoginFlag())
	    	{
		    	lineList.push ( this.rowCanLogin());
	    	}
    	}
	    
	    if ( this.props.addressRequired == true )
	    {
			lineList.push ( this.rowAddressLine1()) ;
			lineList.push ( this.rowAddressLine2()) ;
			lineList.push ( this.rowPostcode()) ;	    	
	    }
	    
        if ( this.props.mode == 'create' || this.props.mode == 'edit')
        {
        	if ( this.props.passwordRequired == true && this.props.autoGeneratePassword != true )
    		{
            	lineList.push ( this.rowPassword()) ;    		
    		}
        	else
    		{
        		if ( this.props.mode == 'create' && this.props.autoGeneratePassword == true )
            	{
                	lineList.push ( this.rowAltPassword ( 'This user will automatically be emailed a randomly generated password' ));         			
            	}
    		}
        }
        
	    lineList.push ( this.buttonRow()) ;
	    
	    if ( this.showInviteFlag())
    	{
	    	lineList.push ( this.inviteToLoginRow());
    	}

	    return  lineList ;
    }

	render() 
    {
		this.keyCount=0;
        return React.createElement('div', { key: this.keyCount++}, this.mainFormElement());
    }
};